export var DropdownMenu: any = function (selector, params) {
    params = params || {};

    params.animation = params.animation;
    params.closeOnClick = params.closeOnClick || true;
    params.direction = params.direction || "bottom right";
    params.hoverDelay = params.hoverDelay || 100;
    params.openOnClick = params.openOnClick || false;
    params.orientation = params.orientation || "horizontal";
    params.popupCollision = params.popupCollision || "fit";

    var menuElement = $(selector);
    if (menuElement && !menuElement.data("kendoMenu")) {
        menuElement.kendoMenu(params);
        menuElement.data("kendoMenu").bind("select", this.handle.bind(this, "select"));
        menuElement.data("kendoMenu").bind("activate", this.handle.bind(this, "activate"));
        menuElement.data("kendoMenu").bind("deactivate", this.handle.bind(this, "deactivate"));
        menuElement.data("kendoMenu").bind("open", this.handle.bind(this, "open"));
        menuElement.data("kendoMenu").bind("close", this.handle.bind(this, "close"));
    }
    this.menu = menuElement.data("kendoMenu");
};

var buildMenuItem = function (content) {
    if (!content || content && !content.content) {
        content = { content: content };
    }

    var element = '<li class="k-item';

    if (content.classes) {
        if ($.isArray(content.classes)) {
            content.classes.forEach(function (value) {
                element += " " + value;
            });
        } else {
            element += " " + content.classes;
        }
    }

    element += '"';
    if (content.id) {
        element += ' id="' + content.id + '"';
    }

    if (content.enabled !== undefined && !content.enabled) {
        element += ' disabled="disabled"';
    }
    element += ">";
    if (content.url) {
        element += '<a class="k-link" href="' + content.url + '">' + content.content + "</a>";
    } else {
        element += content.content;
    }
    return  element + "</li>";
};

var horizontalSeparator: any = function (options) {
    var classes = "z-dropdown-menu-h-separator";
    if (options.classes) {
        if ($.isArray(options.classes)) {
            classes = options.classes.push(classes);
        } else {
            classes += " " + options.classes;
        }
    }
    return {
        classes: classes,
        content: options.content || "<hr/>",
        id: options.id,
        enabled: false
    };
};
horizontalSeparator.classes = "z-dropdown-menu-h-separator";
horizontalSeparator.content = "<hr/>";
horizontalSeparator.enabled = false;

var verticalSeparator: any = function (options) {
    var classes = "z-dropdown-menu-v-separator";
    if (options.classes) {
        if ($.isArray(options.classes)) {
            classes = options.classes.push(classes);
        } else {
            classes += " " + options.classes;
        }
    }
    return {
        classes: classes,
        content: options.content || "/",
        id: options.id,
        enabled: false
    };
};
verticalSeparator.classes = "z-dropdown-menu-v-separator";
verticalSeparator.content = "/";
verticalSeparator.enabled = false;

DropdownMenu.HorizontalSeparator = horizontalSeparator;
DropdownMenu.VerticalSeparator = verticalSeparator;

DropdownMenu.prototype = {

    handlers: {
        select: {},
        activate: {},
        deactivate: {},
        open: {},
        close: {}
    },

    handle(type, e) {
        if (this.handlers[type][$(e.item).attr("id")]) {
            this.handlers[type][$(e.item).attr("id")](e.item);
        } else if (this.handlers[type].__default__) {
            this.handlers[type].__default__(e.item);
        }
    },

    append(content, menuId) {
        if (!$.isArray(content)) {
            content = [content];
        }
        var me = this;
        content.forEach(function (value) {
            me.menu.append(buildMenuItem(value), menuId);

            if (value.id) {
                for (var key in value) {
                    if (/^on/.test(key) && me[key]) {
                        me[key](value[key], value.id);
                    }
                }
            }

            var item = $(value.id ? "#" + value.id : menuId + ":last-child");
            if (value.data) {
                for (var e in value.data) {
                    if (value.data.hasOwnProperty(e)) {
                        item.data(e, value.data[e]);
                    }
                }
            }
        });

        return this;
    },
    insert(content, id, before) {
        if (!$.isArray(content)) {
            content = [content];
        }
        var me = this;
        content.forEach(function (value) {
            me.menu["insert" + (before ? "Before" : "After")](buildMenuItem(value), id);

            if (value.id) {
                for (var key in value) {
                    // startswith vs startsWith ?? -- possible bug
                    if ((key as any).startswith("on") && me[key]) {
                        me[key](value[key], value.id);
                    }
                }

                var item = $("#" + value.id);
                if (value.data) {
                    for (var e in value.data) {
                        if (value.data.hasOwnProperty(e)) {
                            item.data(e, value.data[e]);
                        }
                    }
                }
            }
        });

        return this;
    },
    remove(selector) {
        var menu; // ??
        menu.remove(selector);
        return this;
    },

    // Event Handlers
    onSelect(callback, id) {
        if (typeof callback == "function") {
            if (!id) {
                id = "__default__";
            }
            this.handlers.select[id] = callback;
        }
    },
    onActivate(callback, id) {
        if (typeof callback == "function") {
            if (!id) {
                id = "__default__";
            }
            this.handlers.activate[id] = callback;
        }
    },
    onDeactivate(callback, id) {
        if (typeof callback == "function") {
            if (!id) {
                id = "__default__";
            }
            this.handlers.deactivate[id] = callback;
        }
    },
    onOpen(callback, id) {
        if (typeof callback == "function") {
            if (!id) {
                id = "__default__";
            }
            this.handlers.open[id] = callback;
        }
    },
    onClose(callback, id) {
        if (typeof callback == "function") {
            if (!id) {
                id = "__default__";
            }
            this.handlers.close[id] = callback;
        }
    }
};
